import Vue from 'vue'
import { formatImage, formatDate, formatError, formatSalary } from 'utils/common-methods'

Vue.filter('imageFilter', formatImage)
Vue.filter('dateFilter', formatDate)
Vue.filter('errorFilter', formatError)
Vue.filter('salaryFilter', formatSalary)



// WEBPACK FOOTER //
// ./src/common/filters/index.js